import Button from "@/common/components/Button";
import { useWorkflowShowStore } from "@/features/maintenance/features/workflows/stores/workflowShowStore";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useNavigate } from "react-router-dom";
import MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept from "./manualEntryProposal/EstablishmentAccept";
import MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject from "./manualEntryProposal/EstablishmentReject";

const MaintenanceWorkflowActionsOnGoingEstablishmentChoice = () => {
  const { forwarding } = useWorkflowShowStore();

  const navigate = useNavigate();

  const proposalStatus = forwarding?.establishment_choice_entry?.actual_proposal?.status;

  if (proposalStatus !== 'awaiting_establishment_response') {
    return null;
  }

  const isExecutionEntry = forwarding?.directive_entry_type === MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry;

  return (
    <div className="flex gap-3">
      <MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject
        forwarding={forwarding!}
      />

      {isExecutionEntry ? (
        <Button
          operationKlassToCheckPermission="Establishment::Maintenance::EstablishmentChoice::ManualEntryProposals::EstablishmentAccept"
          onClick={() =>
            navigate(`execution-entry/${forwarding?.id}`)
          }
        >
          Fazer proposta
        </Button>
      ) : (
        <MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept
          forwarding={forwarding!}
        />
      )}
    </div>
  );
}

export default MaintenanceWorkflowActionsOnGoingEstablishmentChoice;
